import React, { useContext } from 'react';
import { ISubcategoryContext, SubcategoryContext } from '../../../subcategoryState/subcategoryContext';
import Text from 'components/Text/Text';
import { Item } from './Item';
import classNames from 'classnames';
import style from './index.module.scss';

export const SubcategoriesByRestaurantList: React.FC = () => {
	const { subcategoriesByRestaurant } = useContext<ISubcategoryContext>(SubcategoryContext);

	const subcategoryHeadingClasses = classNames(style.subcategory, style.heading);
	const categoryNameHeadingClasses = classNames(style.categoryName, style.heading);
	const isHiddenHeadingClasses = classNames(style.isHidden, style.heading);
	const availableForRepetitionHeadingClasses = classNames(style.availableForRepetition, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={subcategoryHeadingClasses}
					translationNameSpace="listing"
					translationKey="subcategoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={categoryNameHeadingClasses}
					translationNameSpace="listing"
					translationKey="categoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={isHiddenHeadingClasses}
					translationNameSpace="listing"
					translationKey="hiddenStatusLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={availableForRepetitionHeadingClasses}
					translationNameSpace="listing"
					translationKey="availableForRepetitionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{subcategoriesByRestaurant.items.map((item, index) => (
				<Item data={item} key={item.id + 'list'} index={index} />
			))}
		</div>
	);
};
